import { ClientEventRow } from '@entities/clients';
import { CALLS_FILTER_ALL } from '../consts';
import { filterAndSortEventClientRows } from './filterAndSortRows';
import { CallsSortDirection, ClientSideFilters, ClientTableView } from './types';

export const selectClientTableView = (
  baseRows: ClientEventRow[],
  clientFilters: ClientSideFilters,
  callsSortDirection: CallsSortDirection
): ClientTableView => ({
  rows: filterAndSortEventClientRows(baseRows, clientFilters, callsSortDirection),
  hasBrokerFilter: clientFilters.selectedBrokersFilter.length > 0,
  hasManagerFilter: clientFilters.isInvitingManagersFilter
    ? clientFilters.selectedInvitingManagersFilter.length > 0
    : clientFilters.selectedAllManagersFilter.length > 0,
  hasCallsFilter: clientFilters.selectedCallsFilter !== CALLS_FILTER_ALL,
});
